// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__32AJr","rootCenter":"LoadMoreObserver_rootCenter__3owxD","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__gnMNA"};